"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeLabel = exports.transporterPatientConditions = exports.transporterSpecificNeeds = exports.cerfaSpecificNeeds = void 0;
// Labels that a downstream reader matches against a specific need or a patient condition: renaming or
// hiding one of them changes what the Cerfa or a connected transporter receives.
exports.cerfaSpecificNeeds = ['Oxygène', 'Isolement protecteur'];
exports.transporterSpecificNeeds = [
    'Oxygène',
    'Fauteuil Roulant',
    'Fauteuil Roulant pliable',
    'Siège enfant',
    'Siège bébé',
];
exports.transporterPatientConditions = ['Surpoids (< 130kg)'];
// Two labels that only differ by case or spaces name the same option
var normalizeLabel = function (label) { return label.toLowerCase().replace(/\s+/g, ''); };
exports.normalizeLabel = normalizeLabel;
//# sourceMappingURL=specific-needs.js.map